import React, { useState, useRef, useEffect } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'
import { useCookies } from 'react-cookie'
import { Container } from 'react-bootstrap'
import moment from 'moment'
import { useRecoilState } from 'recoil'

import Dialog from '../../../1stlog-ui/src/components/Dialog'
import useOrderNews from './useOrderNews'

export { default as useOrderNews } from './useOrderNews'

const Wrapper = styled.div`
  position: absolute;
  top: 20vh;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
`

const GreyOutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 2000;
`

const ContainerWrapper = styled.div`
  background: black;
  color: white;
  padding: 1em;
  margin-top: 20vh;
  width: 30vw;
  box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.2);
`

const TextWrapper = styled.div`
  flex: 1;
`

const ButtonWrapper = styled.div``

const COOKIE_NAME = 'orderNewsRead'

const OrderNews = (props) => {
  const [cookies, setCookie] = useCookies([COOKIE_NAME])

  const { isOpen, open, close, isVisible } = useOrderNews()

  const orderNewsRead = lodash.get(cookies, COOKIE_NAME)

  const newsIsNewer =
    !orderNewsRead ||
    moment(orderNewsRead).isBefore(moment(lodash.get(global.orderNews, 'updated_at')))

  useEffect(() => {
    if (newsIsNewer) {
      open()
    }
  }, [])

  const closeDialog = () => {
    setCookie(COOKIE_NAME, moment(lodash.get(global.orderNews, 'updated_at')).toISOString(), {
      path: '/',
      expires: new Date(Date.now() + 12096e5),
    })
    close()
  }

  const isActuallyOpen = !(!isOpen && (!global.orderNews || (!newsIsNewer && !props.isForced)))

  if (!isVisible) {
    return null
  }

  return (
    <Dialog
      isOpen={isActuallyOpen}
      onClose={closeDialog}
      title={i18n.t('important_information', 'Wichtige Informationen')}
      showCloseIcon
      lg
    >
      <div
        dangerouslySetInnerHTML={{
          __html: lodash.get(global.orderNews, 'content_html'),
        }}
      ></div>
    </Dialog>
  )

  // return (
  //   <GreyOutWrapper className="LoaderOverlay/Wrapper">
  //     <div className="flex-fill" onClick={closeDialog}>
  //       <ContainerWrapper>
  //         <Container className="d-flex">
  //           <TextWrapper
  //             dangerouslySetInnerHTML={{
  //               __html: lodash.get(global.orderNews, "content_html")
  //             }}
  //           ></TextWrapper>

  //           <ButtonWrapper>
  //             <Icon size={1.5} icon="fal fa-times" onClick={closeDialog} />
  //           </ButtonWrapper>
  //         </Container>
  //       </ContainerWrapper>
  //     </div>
  //   </GreyOutWrapper>
  // )
}

export default OrderNews
